import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";

export default function AntecedentesCriminaisQuery({ data }) {
  const hasRecords = data?.possuiAntecedentesCriminais;

  return (
    <section className="mt-6" id="antecedentes-criminais">
      <TitleStripe>Antecedentes Criminais - Polícia Federal</TitleStripe>

      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Nome</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.nome || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">CPF</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.cpf || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Número da certidão</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.numeroCertidao || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
          <p className="text-[11px] text-gray-500">Data de nascimento</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.dataNascimento || "-"}
          </p>
        </div>
      </div>

      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl border border-gray-200 bg-white p-3">
          <p className="text-[11px] text-gray-500">Data de emissão</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.dataEmissao || "-"}
          </p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-white p-3">
          <p className="text-[11px] text-gray-500">Data de validade</p>
          <p className="text-sm font-semibold text-gray-900">
            {data?.dataValidade || "-"}
          </p>
        </div>
      </div>

      <div
        className={`mt-3 rounded-xl border ${hasRecords ? "border-red-100 bg-red-50" : "border-blue-200 bg-blue-50"} p-3`}
      >
        <p className="text-[11px] text-blue-700">Status da certidão</p>
        <p className="text-sm font-medium text-blue-900">
          {data?.status || "-"}
        </p>
      </div>

      {hasRecords ? (
        <div className="mt-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
          Constam apontamentos de antecedentes criminais para o documento
          consultado.
        </div>
      ) : null}
    </section>
  );
}
